import { render, staticRenderFns } from "./Wearable.vue?vue&type=template&id=62b7203d"
import script from "./Wearable.vue?vue&type=script&lang=ts"
export * from "./Wearable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports